<template>
  <div class="left-header">
    <logo />
    <span style="color: #fff">{{
      $store.state.systemConfig.currentVersion
    }}</span>
  </div>
</template>
<script>
import logo from "./logo";
export default {
  components: { logo },
};
</script>
